export const notesActiveEndpoint = (state, payload) => `${state.config.apiUrl}/v1/annotations/notes/${payload.entityId}/active?start=${payload.start}&end=${payload.end}`;
export const notesEndpoint = state => `${state.config.apiUrl}/v1/annotations/notes`;
export const annotationsEndpoint = (state, payload) => `${state.config.apiUrl}/v1/annotations/${payload.annotationId}`;
export const annotationsListEndpoint = state => `${state.config.apiUrl}/v1/annotations/list`;



// WEBPACK FOOTER //
// ./src/services/annotations/selectors.js